import { render } from "./NewTermsPopin.vue?vue&type=template&id=9053410a&scoped=true&ts=true"
import script from "./NewTermsPopin.vue?vue&type=script&lang=ts"
export * from "./NewTermsPopin.vue?vue&type=script&lang=ts"

import "./NewTermsPopin.vue?vue&type=style&index=0&id=9053410a&lang=stylus"
import "./NewTermsPopin.vue?vue&type=style&index=1&id=9053410a&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9053410a"]])

export default __exports__